import React from "react";
import FeatureCard from "./FeatureCard";
import { MdKeyboardArrowLeft, MdKeyboardArrowRight } from "react-icons/md";

const SolutionDetail = ({ solutions, activeIndex, onTabChange }) => {
  if (!solutions || solutions.length === 0) {
    return null;
  }

  const currentSolution = solutions[activeIndex];

  return (
    <div className="lg:w-[1300px]">
      <div className="bg-white/95 backdrop-blur-md rounded-lg shadow-2xl border border-gray-200/50">
        <div className="flex flex-col lg:flex-row pt-2 sm:pt-4 lg:pt-6 pb-2 sm:pb-4 lg:py-6 px-1 sm:px-2 md:px-4 lg:px-8">
          <div className="w-full lg:w-[30%] pe-[20px] relative">
            <button
              onClick={() => onTabChange('prev')}
              className="absolute -left-2 sm:-left-4 lg:-left-10 top-1/2 -translate-y-1/2 z-20 w-8 h-8 sm:w-10 sm:h-10 rounded-full bg-white backdrop-blur-md
                         flex items-center justify-center transition-all duration-300 hover:bg-white hover:scale-105 border border-gray-200/60
                         shadow-lg hover:shadow-xl text-gray-700"
              title="이전 솔루션 (←)"
            >
              <MdKeyboardArrowLeft size={18} className="sm:w-6 sm:h-6" />
            </button>
            <div className="space-y-4 lg:space-y-[30px]">
              <div>
                <h2 className="text-3xl lg:text-4xl font-bold text-gray-800 mb-4">
                  {currentSolution.name}
                </h2>
                <h3 className="text-lg lg:text-xl text-gray-600 leading-relaxed whitespace-pre-line font-[SUIT-Regular]">
                  {currentSolution.title}
                </h3>
              </div>
              
              <div className="border-t border-gray-200 pt-6">
                <p className="text-sm lg:text-base text-gray-700 leading-relaxed whitespace-pre-line font-[SUIT-Regular]">
                  {currentSolution.desc}
                </p>
              </div>
            </div>
          </div>
          
          <div className="hidden lg:block w-[70%] border-s border-gray-300/90 ps-[30px] relative">
            <button
              onClick={() => onTabChange('next')}
              className="absolute -right-2 sm:-right-4 lg:-right-10 top-1/2 -translate-y-1/2 z-20 w-8 h-8 sm:w-10 sm:h-10 rounded-full bg-white backdrop-blur-md
                         flex items-center justify-center transition-all duration-300 hover:bg-white hover:scale-105 border border-gray-200/60
                         shadow-lg hover:shadow-xl text-gray-700"
              title="다음 솔루션 (→)"
            >
              <MdKeyboardArrowRight size={18} className="sm:w-6 sm:h-6" />
            </button>
            <div>
              <h4 className="text-2xl font-bold text-gray-800 mb-6">
                주요 기능
              </h4>
            </div>
            <div className="p-[20px]">
              <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-2 sm:gap-3 md:gap-4 justify-items-center">
                {currentSolution.point.map((feature, index) => (
                  <FeatureCard key={feature.id} feature={feature} />
                ))}
              </div>   
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SolutionDetail; 